'use client'

import { Checkbox, Stack, TextInput } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { Controller } from 'react-hook-form'
import { RegisterMedicalFormValues } from '@lib/schemas/auth-schema'
import { MultistepForm } from '../../../../components/Multistep'

interface Props {
    form: MultistepForm<RegisterMedicalFormValues>
}

export default function MedicalDetailsStep({ form }: Props) {
    const t = useTranslations('auth.register.medical')
    const {
        control,
        register,
        formState: { errors }
    } = form

    return (
        <Stack gap='xl'>
            <TextInput
                aria-label={t('licenseNumber')}
                placeholder={t('licenseNumberPlaceholder')}
                size='lg'
                error={errors.medicalLicenseNumber?.message}
                {...register('medicalLicenseNumber')}
            />

            <Controller
                control={control}
                name='confirmMedicalRole'
                render={({ field }) => (
                    <Checkbox
                        size='lg'
                        checked={field.value}
                        onChange={(e) => field.onChange(e.currentTarget.checked)}
                        label={t('confirmRole')}
                        error={errors.confirmMedicalRole?.message}
                    />
                )}
            />
        </Stack>
    )
}
